import React from 'react';
import { useTranslation } from 'react-i18next';

import Alert from 'components/Common/Alert/Alert';
import Modal from 'components/Common/Modal/Modal';
import Trans from 'components/Common/Translation/Trans';
import { ENV_MEDIAS_URL_ACCOUNT_CATALOG } from 'settings/env';

import styles from './ModalSuccessCatalogRequest.module.scss';

function ModalSuccessCatalogRequest({
  isOpen,
  closeModal,
}: {
  isOpen: boolean;
  closeModal: () => void;
}): JSX.Element | null {
  const { t } = useTranslation(['catalogRequestPage']);
  const closeModalFunction = () => {
    closeModal();
    const body = document.querySelector('body');
    if (body) {
      body.style.overflowY = 'auto';
      return;
    }
  };
  if (!isOpen) {
    return null;
  }

  return (
    <Modal isOpen={isOpen} modalClassName={styles.popupmodal}>
      <header className={styles.modalheader}>
        <h1 className={styles.modaltitle}>
          {t('LABEL_CATALOG_REQUEST_TITLE')}
        </h1>
        <button
          className={styles.actionclose}
          type="button"
          onClick={closeModalFunction}
          aria-label={t('LABEL_CLOSE')}
        >
          <span className={styles.closeIcon} />
        </button>
      </header>
      <div className={styles.modalContent}>
        <div className={styles.alertContent}>
          <Alert
            label={t('LABEL_CATALOG_REQUEST_MODAL_SUCCESS')}
            severity="success"
          />
        </div>
        <div className={styles.textContent}>
          <label>
            <Trans
              i18nKey={'LABEL_CATALOG_REQUEST_MODAL_LABEL'}
              namespace={'catalogRequestPage'}
            />
          </label>
        </div>
        {ENV_MEDIAS_URL_ACCOUNT_CATALOG && (
          <img
            alt={t('LABEL_CATALOG_IMAGE_ALT')}
            className={styles.image}
            src={ENV_MEDIAS_URL_ACCOUNT_CATALOG}
          />
        )}
      </div>
    </Modal>
  );
}

export default ModalSuccessCatalogRequest;
